'use strict';

angular.module('impactx.dropzone').directive('ixDropzone', dropTarget);

dropTarget.$inject = ['$timeout'];

function dropTarget($timeout) {

    return {
        scope:
        {
            uploadFile: "=",
            dropzoneId: "@",
            selectItemMessage: "@",
            fileIcon: "@",
            accept: "@",
            noRead: "=",
            required: "=",
            requiredLabel: "@",
            isReadOnly: "=",
            forceShowDownload: "=",
            clearFileOnUpload: "="
        },
        controller: "DropzoneCtrl",
        controllerAs: 'dropzoneCtrl',
        link: link,
        restrict: 'E',
        templateUrl: 'shared/dropzone/templates/dropzone.tmpl.html'
    };

    function link(scope, element, attrs, ctrl) {
        var formController = element.controller('form');
        if(formController) {
            scope.formController = formController;
        }

        $timeout(function()
        {
            angular.element(document.querySelector('#fileInput' + scope.dropzoneId)).on('change', ctrl.handleFileSelect);
        }, 0);
        var dragCounter = 0;
        element.on('drop', function (e) {
            angular.element(element[0].getElementsByClassName("dropzone")).css('background-color', '');
            e.preventDefault();
            var file = e.originalEvent.dataTransfer.files[0];
            ctrl.handleFile(e, file);
            dragCounter = 0;
        });
        element.on('dragover', function (e) {
            e.originalEvent.dataTransfer.dropEffect = "copy";
            e.preventDefault();
        });
        element.on('dragenter', function (e) {
            dragCounter++;
            if (dragCounter == 1)
            {
                angular.element(element[0].getElementsByClassName("dropzone")).css('background-color', 'rgba(229, 229, 229, .5)');
            }
            e.originalEvent.dataTransfer.dropEffect = "copy";
            e.preventDefault();
        });
        element.on('dragleave', function (e) {
            dragCounter--;
            if (dragCounter <= 0)
            {
                angular.element(element[0].getElementsByClassName("dropzone")).css('background-color', '');
            }
            e.originalEvent.dataTransfer.dropEffect = "none";
            e.preventDefault();
        });
        element.on('dragend', function (e) {
            angular.element(element[0].getElementsByClassName("dropzone")).css('background-color', '');
            e.originalEvent.dataTransfer.dropEffect = "none";
            e.preventDefault();
            dragCounter = 0;
        });
    }
}